import React from 'react';
import PropTypes from 'prop-types';

export default function AccessIcon({ color = '#ffffff', width = 20, height = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height} fill={color}>
      <path d="M312.8 362.7h49.8L281.1 149.3H230.9L149.3 362.7h49.8l16.5-47.5h80.7l16.5 47.5zM256.3 201.9l27.5 78.3H228.2l27.5-78.3h.6zM42.7 256a213.3 213.3 0 1 1 426.7 0A213.3 213.3 0 1 1 42.7 256zm384 0A170.7 170.7 0 1 0 85.3 256a170.7 170.7 0 1 0 341.3 0z" />
    </svg>);
}

AccessIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
